import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DesktopDatePicker } from '@mui/x-date-pickers';

export const Wrapper = styled(Stack)``;

export const DatePicker = styled(DesktopDatePicker)``;
